import {FormField, type FormControl} from 'platform/components';
import {Grid} from 'platform/foundation';

import {useVehicleCatalogue} from '@dms/shared';

import type {EngineAuthoringValues} from '../schemas/engineSchema';
import {FormSection, PASSENGER_CAR, t} from '../utils/catalogueUi';
import {labelWithUnit} from '../utils/labelWithUnit';
import {NumberField} from './NumberField';

/** Battery and charging of an electric or hybrid engine, under the used-vehicle form's labels. */
export function EngineBatteryFields(props: {control: FormControl<EngineAuthoringValues>}) {
  const [catalogue, {isLoading}] = useVehicleCatalogue(PASSENGER_CAR);
  return (
    <FormSection title={t('entity.vehicle.labels.battery')}>
      <Grid columns={2} spacing={3}>
        <NumberField
          control={props.control}
          name="technicalData.batteryCapacityWh"
          label={labelWithUnit('entity.vehicle.labels.batteryCapacity', 'general.metric.kWh')}
        />
        <NumberField
          control={props.control}
          name="technicalData.batteryCapacityAh"
          label={labelWithUnit('entity.vehicle.labels.batteryCapacity', 'general.metric.Ah')}
        />
        <NumberField
          control={props.control}
          name="technicalData.batteryVoltage"
          label={labelWithUnit('entity.vehicle.labels.batteryVoltage', 'general.metric.V')}
        />
        <FormField
          control={props.control}
          name="technicalData.batteryType"
          type="choice"
          menuInPortal
          label={t('entity.vehicle.labels.batteryType')}
          options={catalogue.batteryTypeOptions ?? []}
          isLoading={isLoading}
        />
        <NumberField
          control={props.control}
          name="technicalData.chargingAC"
          label={labelWithUnit('entity.vehicle.labels.batteryChargingAc', 'general.metric.kW')}
        />
        <NumberField
          control={props.control}
          name="technicalData.chargingTimeAC"
          label={labelWithUnit('entity.vehicle.labels.batteryChargingTimeAc', 'general.metric.h')}
        />
        <NumberField
          control={props.control}
          name="technicalData.chargingDC"
          label={labelWithUnit('entity.vehicle.labels.batteryChargingDc', 'general.metric.kW')}
        />
        <NumberField
          control={props.control}
          name="technicalData.chargingTimeDC"
          label={labelWithUnit('entity.vehicle.labels.batteryChargingTimeDc', 'general.metric.min')}
        />
        <FormField
          control={props.control}
          name="technicalData.chargingConnectorType"
          type="choice"
          menuInPortal
          label={t('entity.vehicle.labels.batteryChargingConnectoryType')}
          options={catalogue.chargingConnectorTypeOptions ?? []}
          isLoading={isLoading}
        />
      </Grid>
    </FormSection>
  );
}
